import { jsxs as c, jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#fff",
          d: "m22.004 13.452-3.019-1.732-.521-.224-12.347.085v6.267h15.884z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#F38020",
          d: "M16.508 17.27c.147-.506.09-.971-.156-1.316-.224-.316-.604-.5-1.062-.522l-8.66-.113a.17.17 0 0 1-.133-.07.2.2 0 0 1-.021-.155.24.24 0 0 1 .203-.155l8.737-.112c1.033-.048 2.16-.886 2.553-1.913l.5-1.3a.26.26 0 0 0 .013-.17A5.676 5.676 0 0 0 12.935 7a5.69 5.69 0 0 0-5.389 3.861 2.6 2.6 0 0 0-1.793-.5 2.56 2.56 0 0 0-2.22 3.179A3.635 3.635 0 0 0 0 17.176q.001.264.035.527a.17.17 0 0 0 .168.148h15.983a.22.22 0 0 0 .204-.155z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#FAAE40",
          d: "M19.267 11.707c-.078 0-.161 0-.239.008-.056 0-.104.043-.125.1l-.338 1.174c-.147.505-.09.971.156 1.316.224.316.604.5 1.062.522l1.844.113c.056 0 .104.029.133.07s.035.103.022.154a.24.24 0 0 1-.204.155l-1.92.113c-1.042.048-2.16.886-2.554 1.913l-.141.359c-.03.07.021.142.099.142h6.593a.17.17 0 0 0 .168-.126c.113-.407.177-.838.177-1.28a4.74 4.74 0 0 0-4.733-4.733"
        }
      )
    ]
  }
);
export {
  o as default
};
